export default function FaqData() {
    return [
        {
            title: "What is term insurance?",
            text: [
                "The \"term\" in term insurance refers to the period of time coverage remains in place at a fixed, level price. For example, a 30 year term would have the same coverage amount and annual price for all 30 years of protection. As long as premiums are paid each year, the full coverage will remain inforce."
            ]
        },
        {
            title: "What is decreasing term insurance?",
            text: [
                "Decreasing term life insurance is designed to decrease in coverage amount over time in lock step with your mortgage or other personal or business loans.",
            ]
        },
        {
            title: "Who should purchase life insurance?",
            text: [
                "The reason someone purchases life insurance may vary. Purchase decisions range from tax planning to protecting your family financially in the event of an unexpected death. In most cases, life insurance is the best option to protect your family in the following ways:",
                [
                    "Providing for children or dependents",
                    "Income replacement",
                    "Funeral expenses",
                    "Education expense protection",
                    "Debt payoff"
                ],
            ]
        },
        {
            title: "What is the difference between Term Insurance and Permanent Life Insurance?",
            text: [
                "Term insurance is a lower cost insurance product designed to provide a level death benefit over a fixed period of time i.e. 10 to 30 years. Term insurance is an excellent option to provide protection for specific needs, i.e. a mortgage, college planning, as well as income replacement of the primary household income earner.",
                "Alternatively, permanent life insurance is designed to provide coverage over an entire lifetime, offering a combination of death benefit and tax deferred cash accumulation. Permanent insurance can be used to supplement long-term savings for retirement and offers other tax advantages.",
            ]
        },
        {
            title: "Why is life insurance a business solution?",
            text: [
                "Life insurance serves as a strategic financial tool for individuals and businesses alike. It provides a tax-efficient way to protect against financial risks associated with unexpected events, such as death. For businesses, life insurance can help mitigate risks related to key personnel, business loans, and succession planning. Additionally, life insurance can offer a valuable employee benefit, helping to attract and retain talent.",
            ]
        },
        {
            title: "How much coverage should I purchase?",
            text: [
                "The amount of coverage needed for each person is unique to his or her personal and financial situation. Life insurance has a variety of uses which should be considered, including as protection for family in the case of an untimely death and providing a tax-advantaged inheritance. The Needs Analysis tool makes this calculation easy and helps determine your life insurance need.",
            ]
        },
    ]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/BusinessSolutions/FaqData.js